<template>
  <div class="row q-mb-md">
    <div class="col">
      <h6 class="q-ma-none">
        {{ $t('components.accountPreferencesTab.title') }}
      </h6>
      {{ $t('components.accountPreferencesTab.description') }}
    </div>
    <div class="col text-right">
      <template v-for="button of buttons" :key="button">
        <q-btn
          :color="button.color"
          :label="button.label"
          :outline="button.isOutline"
          :to="button.to"
          class="q-mb-md q-ml-sm"
          @click="button.onClick"
        />
      </template>
    </div>
  </div>

  <div class="row q-col-gutter-md">
    <q-select
      v-model="localAccount.user.locale"
      :options="[
        {
          value: 'en',
          label: $t('components.accountPreferencesTab.locales.en'),
        },
        {
          value: 'it',
          label: $t('components.accountPreferencesTab.locales.it'),
        },
        {
          value: 'es',
          label: $t('components.accountPreferencesTab.locales.es'),
        },
      ]"
      :label="$t('components.accountPreferencesTab.labels.locale')"
      :error="v$.localAccount.user.locale.$error"
      :error-message="v$.localAccount.user.locale.$errors[0]?.$message"
      :readonly="!isEdit"
      class="col-6"
      emit-value
      map-options
      hide-bottom-space
    />
  </div>
</template>

<script>
import _ from 'lodash';
import useValidate from '@vuelidate/core';
import i18n from '@/helpers/i18n';

import { updateAccount } from '@/api/account';

export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      v$: useValidate(),
      isEdit: false,
      localAccount: _.cloneDeep(this.account),
    };
  },
  validations: {
    localAccount: {
      user: {
        locale: {},
      },
    },
  },
  computed: {
    buttons() {
      return [
        {
          isAllowed: this.$isAllowed('doctor/account/update'),
          color: this.isEdit ? 'secondary' : 'primary',
          label: this.isEdit
            ? this.$t('components.accountPreferencesTab.saveButtonTitle')
            : this.$t('components.accountPreferencesTab.editButtonTitle'),
          isOutline: !this.isEdit,
          onClick: this.isEdit ? this.save : this.edit,
        },
      ];
    },
  },
  created() {
    this.updateTitle();
  },
  watch: {},
  methods: {
    updateTitle() {
      this.$emit(
        'update:title',
        this.$t('components.accountPreferencesTab.title')
      );
    },
    edit() {
      this.isEdit = true;
    },
    async save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        try {
          const account = await updateAccount(this.localAccount);

          if (this.localAccount.user.locale !== i18n.locale) {
            i18n.global.locale = this.localAccount.user.locale;
            i18n.locale = this.localAccount.user.locale;
            this.$router.push({
              ...this.$route,
              params: {
                ...this.$route.params,
                locale: this.localAccount.user.locale,
              },
            });
          }

          this.$emit('update:account', account);
          this.updateTitle();

          this.isEdit = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>
